/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileMpp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="m10.75 15.288 1.571-3.305h1.125V17h-1.062v-3.249l-1.325 2.766h-.662l-1.325-2.721V17H8.03v-5.017h1.124zm5.469-3.305c.616 0 1.08.143 1.393.428.318.285.477.709.477 1.27 0 .372-.072.685-.214.938a1.328 1.328 0 0 1-.628.566c-.276.13-.619.194-1.028.194h-.725V17h-1.07v-5.017zm-.725 2.519h.504c.368 0 .628-.062.78-.187.156-.128.234-.34.234-.634 0-.3-.078-.511-.235-.635-.152-.124-.411-.186-.779-.186h-.504zm5.051-2.519c.616 0 1.08.143 1.393.428.318.285.476.709.476 1.27 0 .372-.071.685-.214.938a1.327 1.327 0 0 1-.628.566c-.276.13-.618.194-1.027.194h-.725V17h-1.069v-5.017zm-.725 2.519h.504c.368 0 .628-.062.78-.187.156-.128.234-.34.234-.634 0-.3-.078-.511-.234-.635-.152-.124-.412-.186-.78-.186h-.504z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileMpp as FileMpp };
